/* #2 Load more â€” fetches the next page and appends products to #product-grid.
   Uses event delegation so it survives Dawn's filter/sort re-renders. */
(function () {
  if (window.__ssLoadMoreInit) return;
  window.__ssLoadMoreInit = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.load-more-button');
    if (!btn) return;
    e.preventDefault();

    var url = btn.getAttribute('data-next-url');
    if (!url || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    try {
      var res = await fetch(url);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newGrid = doc.getElementById('product-grid');
      var grid = document.getElementById('product-grid');
      if (newGrid && grid) {
        newGrid.querySelectorAll('li.grid__item').forEach(function (li) {
          var clone = document.importNode(li, true);
          // make appended items visible immediately (scroll-reveal observer won't watch them)
          clone.classList.remove('scroll-trigger', 'animate--slide-in');
          clone.removeAttribute('data-cascade');
          grid.appendChild(clone);
        });
      }

      // advance to the page after this one, or remove the button on the last page
      var nextBtn = doc.querySelector('.load-more-button');
      if (nextBtn && nextBtn.getAttribute('data-next-url')) {
        btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
      } else {
        var wrap = btn.closest('.load-more-wrapper');
        if (wrap) wrap.remove();
      }
    } catch (err) {
      console.error('Load more failed:', err);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  });
})();
